import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import { STATUS_COLORS } from '../utils/config';

export default function OwnerRecords({ user }) {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const res = await API.get('/tasks');
      setRecords(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.back} onClick={() => navigate('/')}>← 返回</button>
        <h2 style={styles.headerTitle}>我的记录</h2>
        <div style={{width:60}} />
      </div>

      <div style={styles.content}>
        {loading ? (
          <div style={styles.empty}>加载中...</div>
        ) : records.length === 0 ? (
          <div style={styles.empty}>暂无提交记录</div>
        ) : (
          records.map(r => (
            <div key={r.id} style={styles.card} onClick={() => toggleExpand(r.id)}>
              <div style={styles.cardTop}>
                <span style={styles.cardType}>{r.source === '投诉建议' ? '📢 投诉建议' : '🔧 报修'}</span>
                <span style={{...styles.statusBadge, background: STATUS_COLORS[r.status] || '#999'}}>
                  {r.status}
                </span>
              </div>
              <div style={styles.cardTitle}>{r.title}</div>
              <div style={styles.cardMeta}>
                <span>{r.location_type === '住宅' ? `${r.building||''}${r.floor||''}${r.room||''}室` : (r.public_area || '')}</span>
                <span>{r.created_at ? new Date(r.created_at).toLocaleDateString() : ''}</span>
              </div>

              {expandedId === r.id && (
                <div style={styles.detail}>
                  {r.solution && (
                    <div style={styles.detailRow}>
                      <span style={styles.detailLabel}>处理方案：</span>{r.solution}
                    </div>
                  )}
                  {r.manager_opinion && (
                    <div style={styles.detailRow}>
                      <span style={styles.detailLabel}>处理回复：</span>{r.manager_opinion}
                    </div>
                  )}
                  {!r.solution && !r.manager_opinion && (
                    <div style={styles.detailRow}>物业还未回复，请耐心等待</div>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', paddingBottom: '30px' },
  header: { background: 'linear-gradient(90deg, #1a4a8a, #2d7dd2)', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 },
  back: { background: 'transparent', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer' },
  headerTitle: { color: '#fff', margin: 0, fontSize: '18px', fontWeight: 700 },
  content: { padding: '16px' },
  empty: { textAlign: 'center', color: '#bbb', padding: '60px 0', fontSize: '14px' },
  card: { background: '#fff', borderRadius: '12px', padding: '14px 16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', cursor: 'pointer' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' },
  cardType: { fontSize: '13px', color: '#666', fontWeight: 600 },
  statusBadge: { color: '#fff', fontSize: '12px', padding: '3px 10px', borderRadius: '12px', fontWeight: 600 },
  cardTitle: { fontSize: '15px', color: '#222', marginBottom: '8px', lineHeight: 1.4 },
  cardMeta: { display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#999' },
  detail: { marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f0f0f0' },
  detailRow: { fontSize: '13px', color: '#555', marginBottom: '6px', lineHeight: 1.5 },
  detailLabel: { fontWeight: 600, color: '#333' }
};
